import TicketPhasesMixin from '../../../mixins/ticket-phases-mixin';

Vue.component("ticket-phases", {
    mixins: [ TicketPhasesMixin ],
    props: {
        ticketPhases: {
            type: Array,
            default: function () {
                return [];
            },
            description: "Team ticket phases"
        }
    },
    data() {
        return {
            ticketPhaseForm: new AppForm({
                phase_name: ""
            }),
            teamTicketPhases: [],
            editablePhase: 0,
        }
    },
    methods: {
        createNewTicketPhase() {
            App.post(`tickets/phases/create`, this.ticketPhaseForm)
            .then(response => {
                if(_.isUndefined(response)) {
                    return false;
                }
                this.teamTicketPhases.push(response.phase);
                this.ticketPhaseForm.phase_name = "";
                toastr.success(response.message);
            });
        },
        removeTicketPhase(phase) {
            if(this.checkPhaseHasTickets(phase)) {
                this.showTicketPhaseActionError();
                return false;
            }

            swal({
                title: "Delete " + phase.phase,
                text: "Are you sure you want to delete this Phase?",
                showCancelButton: true,
                confirmButtonColor: "#f62d51",
                confirmButtonText: "Delete"
            }).then(result => {
                if (result.value) {
                    axios.post(`tickets/phases/${phase.id}/delete`, { _method: "DELETE" })
                    .then(response => {
                        if(_.isUndefined(response)) {
                            return false;
                        }
                        this.removePhaseFromList(phase);
                        toastr.success(response.data.message);
                    })
                }
            });
        },
        makePhaseEditable(phase) {
            if(this.checkPhaseHasTickets(phase)) {
                this.showTicketPhaseActionError();
                this.editablePhase = 0;
                return false;
            }

            this.editablePhase = phase.id;

            Vue.nextTick(() => {
                this.$refs.editPhaseInput[0].focus();
            });
        },
        editTicketPhase(phase) {
            axios.patch(`tickets/phases/${phase.id}/update`, {
                phase_name: phase.phase
            })
            .then(response => {
                if(_.isUndefined(response)) {
                    return false;
                }
                toastr.success(response.data.message);
            });

            this.editablePhase = 0;
        },
        dismissEditInput(event) {
            if(event.relatedTarget !== null && event.relatedTarget.dataset.role === "edit") {
                return;
            }
            this.editablePhase = 0;
        },
        updatePhaseOrders(event) {
            axios.put(`tickets/phases/${event.moved.element.id}/update-order`, {
                new_order: ++event.moved.newIndex,
                old_order: ++event.moved.oldIndex
            })
            .then(response => {
                if(_.isUndefined(response)) {
                    return false;
                }
                this.resetPhaseOrders();
                toastr.success(response.data.message);
            });
        }
    },
    created() {
        this.teamTicketPhases = this.ticketPhases;
    }
});
